import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, messaggioErrore } from '../lib/api'

type Piano = 'pro' | 'team'

/**
 * Hook centralizzato per il flusso di upgrade.
 *
 * Espone due azioni:
 *  - `avviaUpgrade(piano)`  → crea una Stripe Checkout Session e
 *                              reindirizza l'utente sulla pagina di pagamento.
 *  - `vaiAbbonamento()`     → naviga alla pagina interna /app/abbonamento,
 *                              utile per CTA "Scopri i piani" o per piani
 *                              non disponibili in self-service (es. Enterprise).
 *
 * Lo stato `caricamento` tiene traccia di QUALE piano è in corso di
 * elaborazione, così pulsanti diversi nella stessa pagina possono mostrare
 * lo spinner indipendentemente l'uno dall'altro.
 */
export function useUpgrade() {
  const navigate = useNavigate()
  const [caricamento, setCaricamento] = useState<Piano | null>(null)
  const [errore, setErrore] = useState<string | null>(null)

  const avviaUpgrade = async (piano: Piano = 'pro') => {
    setCaricamento(piano)
    setErrore(null)
    try {
      const res = await api.post<{ dati: { checkout_url: string } }>(
        '/stripe/checkout',
        { piano },
      )
      const url = res.data?.dati?.checkout_url
      if (!url) throw new Error('URL di checkout non ricevuto dal server')
      // Redirect su Stripe Checkout (full page navigation)
      window.location.href = url
    } catch (err) {
      setErrore(messaggioErrore(err))
      setCaricamento(null)
    }
  }

  const vaiAbbonamento = () => {
    navigate('/app/abbonamento')
  }

  return {
    avviaUpgrade,
    vaiAbbonamento,
    caricamento,
    errore,
    staCaricando: caricamento !== null,
  }
}
